import {
    GET_KMS_CONTENTS_SUCCESS,
    GET_KMS_CONTENTS_FAIL,
    GET_KMS_ARCHIVED_CONTENTS_SUCCESS,
    GET_KMS_ARCHIVED_CONTENTS_FAIL,
    GET_KMS_TRASHED_CONTENTS_SUCCESS,
    GET_KMS_TRASHED_CONTENTS_FAIL,
    GET_KMS_CONTENTS_BY_REPERTOIRE_SUCCESS,
    GET_KMS_CONTENTS_BY_REPERTOIRE_FAIL,
    GET_KMS_CONTENT_SUCCESS,
    GET_KMS_CONTENT_FAIL,
    CREATE_KMS_CONTENT_SUCCESS,
    CREATE_KMS_CONTENT_FAIL,
    GENERATE_KMS_ARTICLE_DRAFT_SUCCESS,
    GENERATE_KMS_ARTICLE_DRAFT_FAIL,
    UPDATE_KMS_CONTENT_SUCCESS,
    UPDATE_KMS_CONTENT_FAIL,
    CHANGE_KMS_CONTENT_STATUS_SUCCESS,
    CHANGE_KMS_CONTENT_STATUS_FAIL,
    GET_KMS_CONTENT_WORKFLOW_HISTORY_SUCCESS,
    GET_KMS_CONTENT_WORKFLOW_HISTORY_FAIL,
    GET_KMS_CONTENT_COMMENTS_SUCCESS,
    GET_KMS_CONTENT_COMMENTS_FAIL,
    GET_KMS_CONTENT_SUBSCRIPTION_SUCCESS,
    GET_KMS_CONTENT_SUBSCRIPTION_FAIL,
    GET_KMS_CONTENT_RATING_SUMMARY_SUCCESS,
    GET_KMS_CONTENT_RATING_SUMMARY_FAIL,
    CREATE_KMS_CONTENT_COMMENT_SUCCESS,
    CREATE_KMS_CONTENT_COMMENT_FAIL,
    DELETE_KMS_CONTENT_COMMENT_SUCCESS,
    DELETE_KMS_CONTENT_COMMENT_FAIL,
    SUBSCRIBE_KMS_CONTENT_SUCCESS,
    SUBSCRIBE_KMS_CONTENT_FAIL,
    UNSUBSCRIBE_KMS_CONTENT_SUCCESS,
    UNSUBSCRIBE_KMS_CONTENT_FAIL,
    UPSERT_KMS_CONTENT_RATING_SUCCESS,
    UPSERT_KMS_CONTENT_RATING_FAIL,
    DELETE_KMS_CONTENT_SUCCESS,
    DELETE_KMS_CONTENT_FAIL,
    RESTORE_KMS_CONTENT_FROM_ARCHIVE_SUCCESS,
    RESTORE_KMS_CONTENT_FROM_ARCHIVE_FAIL,
    RESTORE_KMS_CONTENT_FROM_TRASH_SUCCESS,
    RESTORE_KMS_CONTENT_FROM_TRASH_FAIL,
    HARD_DELETE_KMS_CONTENT_SUCCESS,
    HARD_DELETE_KMS_CONTENT_FAIL,
    SET_KMS_CONTENT_LIST_LOADING,
    SET_KMS_CONTENT_DETAIL_LOADING,
    SET_KMS_CONTENT_SAVE_LOADING,
    CLEAR_KMS_CONTENT_ERROR,
    CLEAR_KMS_CONTENT_MESSAGE,
    CLEAR_KMS_GENERATED_ARTICLE_DRAFT,
} from "../actions/kmsContentActions";

const initialState = {
    items: [],
    archivedItems: [],
    trashedItems: [],
    lastFilters: {},
    byRepertoire: {},
    workflowHistoryByContent: {},
    commentsByContent: {},
    subscriptionByContent: {},
    ratingSummaryByContent: {},
    commentsLoadingByContent: {},
    subscriptionLoadingByContent: {},
    ratingLoadingByContent: {},
    commentsErrorByContent: {},
    subscriptionErrorByContent: {},
    ratingErrorByContent: {},
    commentSaveLoadingByContent: {},
    subscriptionSaveLoadingByContent: {},
    ratingSaveLoadingByContent: {},
    commentMutationTickByContent: {},
    subscriptionMutationTickByContent: {},
    ratingMutationTickByContent: {},
    currentContent: null,
    listLoading: false,
    detailLoading: false,
    saveLoading: false,
    articleDraftLoading: false,
    generatedArticleDraft: "",
    articleDraftError: "",
    message: "",
    error: null,
};

export default function kmsContentReducer(state = initialState, action) {
    switch (action.type) {
        case SET_KMS_CONTENT_LIST_LOADING:
            return { ...state, listLoading: action.payload };

        case SET_KMS_CONTENT_DETAIL_LOADING:
            return { ...state, detailLoading: action.payload };

        case SET_KMS_CONTENT_SAVE_LOADING:
            return { ...state, saveLoading: action.payload };

        case "SET_KMS_ARTICLE_DRAFT_LOADING":
            return { ...state, articleDraftLoading: action.payload };

        case "SET_KMS_CONTENT_COMMENTS_LOADING":
            return {
                ...state,
                commentsLoadingByContent: {
                    ...state.commentsLoadingByContent,
                    [action.payload.contentId]: action.payload.loading,
                },
                commentsErrorByContent: {
                    ...state.commentsErrorByContent,
                    [action.payload.contentId]: action.payload.loading
                        ? null
                        : state.commentsErrorByContent[action.payload.contentId],
                },
            };

        case "SET_KMS_CONTENT_COMMENT_SAVE_LOADING":
            return {
                ...state,
                commentSaveLoadingByContent: {
                    ...state.commentSaveLoadingByContent,
                    [action.payload.contentId]: action.payload.loading,
                },
            };

        case "SET_KMS_CONTENT_SUBSCRIPTION_LOADING":
            return {
                ...state,
                subscriptionLoadingByContent: {
                    ...state.subscriptionLoadingByContent,
                    [action.payload.contentId]: action.payload.loading,
                },
                subscriptionErrorByContent: {
                    ...state.subscriptionErrorByContent,
                    [action.payload.contentId]: action.payload.loading
                        ? null
                        : state.subscriptionErrorByContent[action.payload.contentId],
                },
            };

        case "SET_KMS_CONTENT_SUBSCRIPTION_SAVE_LOADING":
            return {
                ...state,
                subscriptionSaveLoadingByContent: {
                    ...state.subscriptionSaveLoadingByContent,
                    [action.payload.contentId]: action.payload.loading,
                },
            };

        case "SET_KMS_CONTENT_RATING_LOADING":
            return {
                ...state,
                ratingLoadingByContent: {
                    ...state.ratingLoadingByContent,
                    [action.payload.contentId]: action.payload.loading,
                },
                ratingErrorByContent: {
                    ...state.ratingErrorByContent,
                    [action.payload.contentId]: action.payload.loading
                        ? null
                        : state.ratingErrorByContent[action.payload.contentId],
                },
            };

        case "SET_KMS_CONTENT_RATING_SAVE_LOADING":
            return {
                ...state,
                ratingSaveLoadingByContent: {
                    ...state.ratingSaveLoadingByContent,
                    [action.payload.contentId]: action.payload.loading,
                },
            };

        case GET_KMS_CONTENTS_SUCCESS:
            return {
                ...state,
                items: action.payload.items || [],
                lastFilters: action.payload.filters || {},
                error: null,
            };

        case GET_KMS_ARCHIVED_CONTENTS_SUCCESS:
            return {
                ...state,
                archivedItems: action.payload || [],
                error: null,
            };

        case GET_KMS_TRASHED_CONTENTS_SUCCESS:
            return {
                ...state,
                trashedItems: action.payload || [],
                error: null,
            };

        case GET_KMS_CONTENTS_BY_REPERTOIRE_SUCCESS:
            return {
                ...state,
                byRepertoire: {
                    ...state.byRepertoire,
                    [action.payload.repertoireId]: action.payload.items || [],
                },
                error: null,
            };

        case GET_KMS_CONTENT_SUCCESS:
            return {
                ...state,
                currentContent: action.payload,
                error: null,
            };

        case CREATE_KMS_CONTENT_SUCCESS:
            return {
                ...state,
                currentContent: action.payload,
                generatedArticleDraft: "",
                articleDraftError: "",
                message: "Contenu cree avec succes",
                error: null,
            };

        case GENERATE_KMS_ARTICLE_DRAFT_SUCCESS:
            return {
                ...state,
                generatedArticleDraft: action.payload || "",
                articleDraftError: "",
                error: null,
            };

        case UPDATE_KMS_CONTENT_SUCCESS:
            return {
                ...state,
                currentContent: action.payload,
                articleDraftError: "",
                message: "Contenu mis a jour avec succes",
                error: null,
            };

        case CHANGE_KMS_CONTENT_STATUS_SUCCESS:
            return {
                ...state,
                currentContent: action.payload,
                articleDraftError: "",
                message: "Statut du contenu mis a jour avec succes",
                error: null,
            };

        case GET_KMS_CONTENT_WORKFLOW_HISTORY_SUCCESS:
            return {
                ...state,
                workflowHistoryByContent: {
                    ...state.workflowHistoryByContent,
                    [action.payload.contentId]: action.payload.items || [],
                },
                error: null,
            };

        case GET_KMS_CONTENT_COMMENTS_SUCCESS:
            return {
                ...state,
                commentsByContent: {
                    ...state.commentsByContent,
                    [action.payload.contentId]: action.payload.items || [],
                },
                commentsLoadingByContent: {
                    ...state.commentsLoadingByContent,
                    [action.payload.contentId]: false,
                },
                commentsErrorByContent: {
                    ...state.commentsErrorByContent,
                    [action.payload.contentId]: null,
                },
            };

        case GET_KMS_CONTENT_SUBSCRIPTION_SUCCESS:
            return {
                ...state,
                subscriptionByContent: {
                    ...state.subscriptionByContent,
                    [action.payload.contentId]: action.payload.subscription || { contentId: action.payload.contentId, subscribed: false },
                },
                subscriptionLoadingByContent: {
                    ...state.subscriptionLoadingByContent,
                    [action.payload.contentId]: false,
                },
                subscriptionErrorByContent: {
                    ...state.subscriptionErrorByContent,
                    [action.payload.contentId]: null,
                },
            };

        case GET_KMS_CONTENT_RATING_SUMMARY_SUCCESS:
            return {
                ...state,
                ratingSummaryByContent: {
                    ...state.ratingSummaryByContent,
                    [action.payload.contentId]: action.payload.summary || null,
                },
                ratingLoadingByContent: {
                    ...state.ratingLoadingByContent,
                    [action.payload.contentId]: false,
                },
                ratingErrorByContent: {
                    ...state.ratingErrorByContent,
                    [action.payload.contentId]: null,
                },
            };

        case CREATE_KMS_CONTENT_COMMENT_SUCCESS:
        case DELETE_KMS_CONTENT_COMMENT_SUCCESS:
            return {
                ...state,
                commentSaveLoadingByContent: {
                    ...state.commentSaveLoadingByContent,
                    [action.payload.contentId]: false,
                },
                commentsErrorByContent: {
                    ...state.commentsErrorByContent,
                    [action.payload.contentId]: null,
                },
                commentMutationTickByContent: {
                    ...state.commentMutationTickByContent,
                    [action.payload.contentId]: (state.commentMutationTickByContent[action.payload.contentId] || 0) + 1,
                },
            };

        case SUBSCRIBE_KMS_CONTENT_SUCCESS:
        case UNSUBSCRIBE_KMS_CONTENT_SUCCESS:
            return {
                ...state,
                subscriptionByContent: {
                    ...state.subscriptionByContent,
                    [action.payload.contentId]: action.payload.subscription || {
                        contentId: action.payload.contentId,
                        subscribed: action.type === SUBSCRIBE_KMS_CONTENT_SUCCESS,
                    },
                },
                subscriptionSaveLoadingByContent: {
                    ...state.subscriptionSaveLoadingByContent,
                    [action.payload.contentId]: false,
                },
                subscriptionErrorByContent: {
                    ...state.subscriptionErrorByContent,
                    [action.payload.contentId]: null,
                },
                subscriptionMutationTickByContent: {
                    ...state.subscriptionMutationTickByContent,
                    [action.payload.contentId]: (state.subscriptionMutationTickByContent[action.payload.contentId] || 0) + 1,
                },
            };

        case UPSERT_KMS_CONTENT_RATING_SUCCESS:
            return {
                ...state,
                ratingSummaryByContent: action.payload.summary
                    ? {
                        ...state.ratingSummaryByContent,
                        [action.payload.contentId]: action.payload.summary,
                    }
                    : state.ratingSummaryByContent,
                ratingSaveLoadingByContent: {
                    ...state.ratingSaveLoadingByContent,
                    [action.payload.contentId]: false,
                },
                ratingErrorByContent: {
                    ...state.ratingErrorByContent,
                    [action.payload.contentId]: null,
                },
                ratingMutationTickByContent: {
                    ...state.ratingMutationTickByContent,
                    [action.payload.contentId]: (state.ratingMutationTickByContent[action.payload.contentId] || 0) + 1,
                },
            };

        case DELETE_KMS_CONTENT_SUCCESS: {
            const { id, repertoireId } = action.payload;
            const nextByRepertoire = { ...state.byRepertoire };

            if (repertoireId && nextByRepertoire[repertoireId]) {
                nextByRepertoire[repertoireId] = nextByRepertoire[repertoireId].filter((item) => item.id !== id);
            }

            return {
                ...state,
                byRepertoire: nextByRepertoire,
                currentContent: state.currentContent?.id === id ? null : state.currentContent,
                message: "Contenu archivé avec succes",
                error: null,
            };
        }

        case RESTORE_KMS_CONTENT_FROM_ARCHIVE_SUCCESS:
            return {
                ...state,
                archivedItems: state.archivedItems.filter((item) => item.id !== action.payload?.id),
                currentContent: state.currentContent?.id === action.payload?.id ? action.payload : state.currentContent,
                message: "Contenu restauré depuis les archives",
                error: null,
            };

        case RESTORE_KMS_CONTENT_FROM_TRASH_SUCCESS:
            return {
                ...state,
                trashedItems: state.trashedItems.filter((item) => item.id !== action.payload?.id),
                currentContent: state.currentContent?.id === action.payload?.id ? action.payload : state.currentContent,
                message: "Contenu restauré depuis la corbeille",
                error: null,
            };

        case HARD_DELETE_KMS_CONTENT_SUCCESS: {
            const { id, source } = action.payload;

            return {
                ...state,
                archivedItems: source === "archive"
                    ? state.archivedItems.filter((item) => item.id !== id)
                    : state.archivedItems,
                trashedItems: source === "trash"
                    ? state.trashedItems.filter((item) => item.id !== id)
                    : state.trashedItems,
                currentContent: state.currentContent?.id === id ? null : state.currentContent,
                message: "Contenu supprime definitivement",
                error: null,
            };
        }

        case GET_KMS_CONTENTS_FAIL:
        case GET_KMS_ARCHIVED_CONTENTS_FAIL:
        case GET_KMS_TRASHED_CONTENTS_FAIL:
        case GET_KMS_CONTENTS_BY_REPERTOIRE_FAIL:
        case GET_KMS_CONTENT_FAIL:
        case GET_KMS_CONTENT_WORKFLOW_HISTORY_FAIL:
        case CREATE_KMS_CONTENT_FAIL:
        case GENERATE_KMS_ARTICLE_DRAFT_FAIL:
            return {
                ...state,
                articleDraftError: action.error,
                error: action.error,
            };

        case GET_KMS_CONTENT_COMMENTS_FAIL:
            return {
                ...state,
                commentsLoadingByContent: {
                    ...state.commentsLoadingByContent,
                    [action.payload.contentId]: false,
                },
                commentsErrorByContent: {
                    ...state.commentsErrorByContent,
                    [action.payload.contentId]: action.error,
                },
            };

        case GET_KMS_CONTENT_SUBSCRIPTION_FAIL:
            return {
                ...state,
                subscriptionLoadingByContent: {
                    ...state.subscriptionLoadingByContent,
                    [action.payload.contentId]: false,
                },
                subscriptionErrorByContent: {
                    ...state.subscriptionErrorByContent,
                    [action.payload.contentId]: action.error,
                },
            };

        case GET_KMS_CONTENT_RATING_SUMMARY_FAIL:
            return {
                ...state,
                ratingLoadingByContent: {
                    ...state.ratingLoadingByContent,
                    [action.payload.contentId]: false,
                },
                ratingErrorByContent: {
                    ...state.ratingErrorByContent,
                    [action.payload.contentId]: action.error,
                },
            };

        case CREATE_KMS_CONTENT_COMMENT_FAIL:
        case DELETE_KMS_CONTENT_COMMENT_FAIL:
            return {
                ...state,
                commentSaveLoadingByContent: {
                    ...state.commentSaveLoadingByContent,
                    [action.payload.contentId]: false,
                },
                commentsErrorByContent: {
                    ...state.commentsErrorByContent,
                    [action.payload.contentId]: action.error,
                },
            };

        case SUBSCRIBE_KMS_CONTENT_FAIL:
        case UNSUBSCRIBE_KMS_CONTENT_FAIL:
            return {
                ...state,
                subscriptionSaveLoadingByContent: {
                    ...state.subscriptionSaveLoadingByContent,
                    [action.payload.contentId]: false,
                },
                subscriptionErrorByContent: {
                    ...state.subscriptionErrorByContent,
                    [action.payload.contentId]: action.error,
                },
            };

        case UPSERT_KMS_CONTENT_RATING_FAIL:
            return {
                ...state,
                ratingSaveLoadingByContent: {
                    ...state.ratingSaveLoadingByContent,
                    [action.payload.contentId]: false,
                },
                ratingErrorByContent: {
                    ...state.ratingErrorByContent,
                    [action.payload.contentId]: action.error,
                },
            };

        case UPDATE_KMS_CONTENT_FAIL:
        case CHANGE_KMS_CONTENT_STATUS_FAIL:
        case DELETE_KMS_CONTENT_FAIL:
        case RESTORE_KMS_CONTENT_FROM_ARCHIVE_FAIL:
        case RESTORE_KMS_CONTENT_FROM_TRASH_FAIL:
        case HARD_DELETE_KMS_CONTENT_FAIL:
            return { ...state, error: action.error };

        case CLEAR_KMS_CONTENT_ERROR:
            return { ...state, error: null };

        case CLEAR_KMS_CONTENT_MESSAGE:
            return { ...state, message: "" };

        case CLEAR_KMS_GENERATED_ARTICLE_DRAFT:
            return { ...state, generatedArticleDraft: "", articleDraftError: "" };

        default:
            return state;
    }
}
